type PrevisionDirection = "prev" | "next";

export const getPrevisionButtonStatus = ({
	dateSelected,
	direction,
	addDate = 10,
}: {
	dateSelected: Date;
	direction: PrevisionDirection;
	addDate?: number;
}): boolean => {
	const today = new Date();
	today.setHours(0, 0, 0, 0);

	const maxDate = new Date(today);
	maxDate.setDate(today.getDate() + addDate);

	const selected = new Date(dateSelected);
	selected.setHours(0, 0, 0, 0);

	if (direction === "prev") {
		return selected > today;
	}

	return selected < maxDate;
};
